import script from "./ProductCardBenefits.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductCardBenefits.vue?vue&type=script&setup=true&lang=ts"

import "./ProductCardBenefits.vue?vue&type=style&index=0&id=55414479&lang=scss"

const __exports__ = script;

export default __exports__